export default __webpack_public_path__ + "static/media/06-FloweryDonut.36713b5e.png";